import ApiService from '@/services/api.service'

const NoteInjectionAssessments = {

    getAll(parameter){
        
        const requestData = {
          method: 'get',
          url: "/NoteInjectionAssessments/",
          headers: {
            
          },
          params: {
            HeaderID: parameter.HeaderID,
            TitleRecNo: parameter.TitleRecNo,
            PageSize: parameter.PageSize,
          }
        }
        return ApiService.customRequest(requestData);
    },

    Add(data){
      return ApiService.post(`/NoteInjectionAssessments/`, data);
    },

    Update(Id,data){        
      return ApiService.put(`/NoteInjectionAssessments/${Id}`,data);
    },
    
    Delete(id){
      return ApiService.delete(`/NoteInjectionAssessments/${id}`)
    },
  }

export default NoteInjectionAssessments;